__turbopack_context__.v({
  "cardWrapper": "channelCardGroup-module-scss-module__QHLhqq__cardWrapper",
  "group": "channelCardGroup-module-scss-module__QHLhqq__group",
  "headline": "channelCardGroup-module-scss-module__QHLhqq__headline",
  "lastCard": "channelCardGroup-module-scss-module__QHLhqq__lastCard",
  "mobileLink": "channelCardGroup-module-scss-module__QHLhqq__mobileLink",
});
